import actionCreator from '../../../utils/actionCreator';

const productsActionTypes = ['GET_PRODUCTS', 'GET_PRODUCT', 'EDIT_PRODUCT', 'SEARCH_PRODUCTS'];

export const { types: productsTypes, actions: productsActions } =
  actionCreator(productsActionTypes);
